import styled from "styled-components";
import { Box } from "@mui/material";

export const CMBoxcontainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",

  [`@media${props.theme.breakpoints.lg}`]: {
    height: "auto",
  },
  [`@media${props.theme.breakpoints.xs}`]: {
    height: "auto",
  },
}));
export const CMBox = styled(Box)((props) => ({
  textAlign: "center",
  backgroundColor: " #efdcde",
  borderRadius: 33,
  height: 153,
  marginTop: 60,
  paddingLeft: "2%",
  paddingRight: "2%",
  marginLeft: "2%",
  marginRight: "2%",
  "& h3": {
    paddingTop: "6%",
    paddingLeft: "10%",
    paddingRight: "10%",
    color:"rgb(197, 75, 75)",
    fontWeight:"bold"
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    height: "auto !important",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    height: "auto !important",
  },
}));

export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  paddingBottom: "5%",
  paddingTop: 94,
  "& Button": {
    height: 53,
    width: 204,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
    borderRadius: 30,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));
